import { render, staticRenderFns } from "./HisInformationItemSelectDialog.vue?vue&type=template&id=48533d60&scoped=true&"
import script from "./HisInformationItemSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./HisInformationItemSelectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./HisInformationItemSelectDialog.vue?vue&type=style&index=0&id=48533d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48533d60",
  null
  
)

export default component.exports